// wait for the DOM to be loaded
document.addEventListener("DOMContentLoaded", function () {
  let productPage = document.querySelector(".body-template-product");

  if (!productPage) {
    // console.log("Product page not found");
    return;
  }

  // console.log("Product page found");
  let zippyContainer = document.querySelector(".zippy-container");

  if (zippyContainer) {
    let observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.addedNodes.length > 0) {
          setTimeout(function () {
            let zippy = document.querySelector("#zippy_widget_1511");
            if (zippy) {
              // console.log("Zippy widget found");

              let isValue = zippy.querySelector("#pin_fail");

              // console.log(isValue);

              if (isValue) {
                let checkoutButton = document.querySelector(".product-form__checkout");
                let cartCheckoutButton = document.querySelector("#CartDrawer-Checkout");

                // console.log(checkoutButton);
                if (checkoutButton) {
                  checkoutButton.classList.add("disable");
                  cartCheckoutButton.classList.add("disable");
                  localStorage.setItem("zippy", "false");
                }
              } else {
                //   wait a seconds before checking the zippy content
                setTimeout(function () {
                  let zippyContent = zippy.querySelector(".zippy-failure");
                  if (zippyContent && zippyContent.innerHTML.includes("Unfortunately")) {
                    let checkoutButton = document.querySelector(".product-form__checkout");
                    let cartCheckoutButton = document.querySelector("#CartDrawer-Checkout");
                    if (checkoutButton) {
                      checkoutButton.classList.add("disable");
                      cartCheckoutButton.classList.add("disable");
                      //add to local storage zippy false
                      localStorage.setItem("zippy", "false");
                    }
                  } else {
                    let checkoutButton = document.querySelector(".product-form__checkout");
                    let cartCheckoutButton = document.querySelector("#CartDrawer-Checkout");
                    if (checkoutButton.classList.contains("disable")) {
                      checkoutButton.classList.remove("disable");
                      cartCheckoutButton.classList.remove("disable");
                      //add to local storage zippy true
                      localStorage.setItem("zippy", "true");
                    }
                  }
                }, 1000);
              }
            } else {
              // console.log("Zippy widget not found");
            }
          }, 1000);
        }
      });
    });

    // Start observing the target node for configured mutations
    observer.observe(zippyContainer, { childList: true, subtree: true });
  }
});
